import Lookup from "./Lookup";

export default Lookup;